import SimpleParallax from 'simple-parallax-js';

import { SELECTORS } from '../../config/constants';

const CONFIG = {
  orientation: 'down',
  overflow: true,
  scale: 1.3,
};

export default function () {
  const imgEl = document.querySelector(SELECTORS.HERO_IMG);

  if (!(imgEl instanceof HTMLImageElement)) {
    return;
  }

  new SimpleParallax(imgEl, CONFIG);
}
